import { NavLink } from "react-router-dom"; 
export default function Button({text , click}){
    return (
        <button 
        className={click ? "sm:text-[1.2rem] md:text-[1.7rem] lg:text-xl bg-orange limit font-aljazeera font-bold leading-10  mx-auto sm:px-5 sm:py-2 lg:px-6 lg:py-2  xl:py-2 xl:px-9 sm:font-aljazeera rounded-md btn sm:hidden md:hidden lg:block" 
        : "sm:text-[1.2rem] md:text-[1.7rem] lg:text-xl bg-orange font-bold limit rounded-md md:btn sm:py-2 sm:px-5 md:py-3 md:px-6 lg:py-2 lg:px-6 xl:py-2.5 xl:px-10 lg:block font-aljazeera sm:font-aljazeera btn" }>
            <NavLink to='/joinUs'>{text}</NavLink>
        </button>
    );
}


